import { storeUtils } from "./store-utils";



const s = storeUtils.namespace('fanfanlo')

function getItem<T>(key:string, defaultValue?:T):T{
    let v = localStorage.getItem(key);
    if(v){

        try{
            let x = JSON.parse(v);
            return x as T;
        }catch(e){
            console.log("storage get item err", e);
        }
    }
    return defaultValue || (v as T);
}

function setItem(key:string, v:any){
    try{
        let s = JSON.stringify(v);
        localStorage.setItem(key, s);
    }catch (e){ console.log("err", e) }finally {}
}

function removeItem(key:string){
    localStorage.removeItem(key)
}
function clear(){
    const bl = window.confirm("are you sure you want to clear all the storage items?")
    if(bl === true){
        localStorage.clear();
        console.log("local storage cleared")
    }
}
export const storage = {
    getItem:s.read,
    setItem:s.write,
    removeItem:s.remove,
    clear:s.clearAll,
}

